import { BotMessageStrategy } from '../Strategies/botMessageStrategy'
import { CustomMessageStrategy } from '../Strategies/customMessageStrategy'

class ActionProvider {
  constructor(sendMessage) {
    this.sendMessage = sendMessage
    this.botMessageStrategy = new BotMessageStrategy()
    this.customMessageStrategy = new CustomMessageStrategy()
  }

  sendBotMessage(message) {
    this.botMessageStrategy.send(message, this.sendMessage)
  }

  async sendCustomMessage(componentName, payload) {
    await this.customMessageStrategy.send(componentName, this.sendMessage, payload)
  }
}

export default ActionProvider